import { render, staticRenderFns } from "./Complete.vue?vue&type=template&id=0222128c&scoped=true"
import script from "./Complete.vue?vue&type=script&lang=js"
export * from "./Complete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222128c",
  null
  
)

export default component.exports